import axios from "axios";
import Config from "../../config";

/** Andamento dos pedidos de print/gravação feitos ao visitante do webchat. */
const actionListaMidiasPorChat = (chatId) =>
    axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/chat/${chatId}/midia`,
    });

export default actionListaMidiasPorChat;
